import React from "react";
import Title from "../Commons/Title";
import {
  Col,
  Row,
  Wrapper,
  Container,
  Image,
  Text,
  P,
  H2,
  Date,
  Span,
} from "./style";
import { useContext } from "react";
import { ThemeContext } from "../../ThemedContext/Provider";
import { Icon } from "semantic-ui-react";

const image1 = "../../../assets/images/blog1.png";
const image2 = "../../../assets/images/blog2.png";
const image3 = "../../../assets/images/blog3.png";
const image4 = "../../../assets/images/blog4.png";
// const image5 = "../../../assets/images/blog5.png";

const contents = [
  { image: image1, title: "Celebrating Winter Holidays" },
  { image: image2, title: "Celebrating Winter Holidays" },
  { image: image3, title: "Celebrating Winter Holidays" },
  { image: image4, title: "Celebrating Winter Holidays" },
];

const Blogs = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper>
      <Container>
        <Title title='LATEST NEWS' />
        <Row>
          {contents.map((content, idx) => (
            <Col key={idx} themed={theme}>
              <Image>
                <img src={content.image} alt='blog' />
              </Image>
              <Text>
                <Date>
                  <Icon name='calendar' size='big' color='orange' />
                  <span>3 May, 2020</span>
                </Date>
                <H2>{content.title}</H2>
                <P>
                  Lorem ipsum dolor sit amet, consect etur adipisicing elit, sed
                  do this dolor sit..
                </P>
                <Span>Read More...</Span>
              </Text>
            </Col>
          ))}
        </Row>
      </Container>
    </Wrapper>
  );
};

export default Blogs;
